import EverTrue from 'app';
import { formatCurrency } from '../utils/index';

const DEMO_URL = 'https://www.evertrue.com/donorsearch-demo/';

const trackUpsellClick = (category) => {
  EverTrue.track.set('enrichment_action', { type: 'upsell_click', category });
};

const CATEGORY_LABELS = {
  charitable: 'charitable giving',
  political: 'political giving',
  realEstate: 'real estate',
  sec: 'SEC',
};

/**
 * Builds an upsell message for DonorSearch drill-down access.
 * When data is available, includes a summary prefix (e.g., "10 charitable giving matches totaling $1,530").
 */
export const buildUpsellMessage = (category, highCount, amount) => {
  const formattedAmount = formatCurrency(amount);
  const hasData = highCount > 0 && amount > 0;

  const prefix =
    hasData && CATEGORY_LABELS[category]
      ? `${highCount} ${CATEGORY_LABELS[category]} matches totaling ${formattedAmount} are ready for review. `
      : '';

  return (
    <span>
      {prefix}Want to unlock full drill-down access and deeper prospect intelligence? Contact your CSM or{' '}
      <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackUpsellClick(category)}>
        request a demo
      </a>{' '}
      to see how DonorSearch can power smarter fundraising decisions.
    </span>
  );
};

export { DEMO_URL, trackUpsellClick };
